import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
const container = document.getElementById("root");
import { AppStateContextProvider } from "@contexts/app-state";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

if (!container) throw new Error("Failed to find container element");
const root = createRoot(container);

const queryClient = new QueryClient();

root.render(
  <AppStateContextProvider>
    <QueryClientProvider client={queryClient}>
      <App />
      <ReactQueryDevtools buttonPosition="top-left" initialIsOpen={false} />
    </QueryClientProvider>
  </AppStateContextProvider>,
);
